import { AppPageHeader } from '@/components/_common';
import { ListInsurersQuery } from '@/core/domain/people/Insurers/Insurers.types';
import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';
import { Button } from 'antd';

import { useIntl } from 'react-intl';
import InsurerExtraFilters from '../InsurersExtraFilters';

const InsurersFilters: React.FC<ExtraFiltersProps<ListInsurersQuery>> = ({
  queryParams,
  setQueryParams,
}) => {
  const intl = useIntl();

  return (
    <AppPageHeader
      onSearch={(value) =>
        setQueryParams((prev) => ({ ...prev, search: value }))
      }
      searchValue={queryParams?.search}
      extraFilters={
        <InsurerExtraFilters
          queryParams={queryParams}
          setQueryParams={setQueryParams}
        />
      }
      headerActions={({
        isShowingFilters,
      }: {
        // eslint-disable-next-line react/no-unused-prop-types
        isShowingFilters: boolean;
      }) =>
        isShowingFilters && (
          <Button type="primary" onClick={() => setQueryParams({})}>
            {intl.formatMessage({ id: 'commons.clear.filters' })}
          </Button>
        )
      }
    />
  );
};

export default InsurersFilters;
